module.exports = __webpack_public_path__ + "static/media/tugrulAnsay.bd15fa04.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/tugrulAnsay.jpg
// module id = 1287
// module chunks = 1